// extracted by mini-css-extract-plugin
export default {"headline":"Headline-module__headline___YPHuj"};